<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/5 xl:w-1/5">
        <vx-card class="overflow-hidden mb-base">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              Cancel
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
}
</script>
